import { gql } from "@apollo/client";

// Asset fragments
export const ASSET_FRAGMENT = gql`
  fragment AssetFields on Asset {
    id
    name
    type
    status
    files {
      id
      filename
      contentType
      size
      uploadedAt
    }
    venue {
      name
      latitude
      longitude
    }
    conversationIds
    createdAt
    updatedAt
    version
  }
`;

// Queries
export const LIST_ASSETS = gql`
  query ListAssets($filter: AssetFilterInput, $limit: Int, $nextToken: String) {
    listAssets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        ...AssetFields
      }
      nextToken
      total
    }
  }
  ${ASSET_FRAGMENT}
`;

export const GET_ASSET = gql`
  query GetAsset($id: ID!) {
    getAsset(id: $id) {
      ...AssetFields
    }
  }
  ${ASSET_FRAGMENT}
`;

// Mutations
export const CREATE_ASSET = gql`
  mutation CreateAsset($input: CreateAssetInput!) {
    createAsset(input: $input) {
      ...AssetFields
    }
  }
  ${ASSET_FRAGMENT}
`;

export const UPDATE_ASSET = gql`
  mutation UpdateAsset($id: ID!, $input: UpdateAssetInput!) {
    updateAsset(id: $id, input: $input) {
      ...AssetFields
    }
  }
  ${ASSET_FRAGMENT}
`;

export const DELETE_ASSET = gql`
  mutation DeleteAsset($id: ID!) {
    deleteAsset(id: $id)
  }
`;

export const ARCHIVE_ASSET = gql`
  mutation ArchiveAsset($id: ID!) {
    archiveAsset(id: $id) {
      ...AssetFields
    }
  }
  ${ASSET_FRAGMENT}
`;

export const CREATE_BULK_ASSETS = gql`
  mutation CreateBulkAssets($input: BulkCreateAssetInput!) {
    createBulkAssets(input: $input) {
      ...AssetFields
    }
  }
  ${ASSET_FRAGMENT}
`;

export const EXPORT_ASSETS = gql`
  query ExportAssets($filter: AssetFilterInput, $format: ExportFormat) {
    exportAssets(filter: $filter, format: $format) {
      downloadUrl
      filename
      recordCount
      expiresAt
    }
  }
`;

export const GENERATE_ASSET_UPLOAD_URL = gql`
  mutation GetUploadUrl(
    $assetId: ID!
    $filename: String!
    $contentType: String!
  ) {
    generateAssetUploadUrl(
      assetId: $assetId
      filename: $filename
      contentType: $contentType
    ) {
      uploadUrl
      fileId
      s3Key
    }
  }
`;

export const ASSOCIATE_FILE_WITH_ASSET = gql`
  mutation AssociateFileWithAsset($assetId: ID!, $fileId: ID!) {
    associateFileWithAsset(assetId: $assetId, fileId: $fileId) {
      ...AssetFields
    }
  }
  ${ASSET_FRAGMENT}
`;

// General file upload mutation (not asset-specific)
export const UPLOAD_FILE = gql`
  mutation UploadFile($input: UploadFileInput!) {
    uploadFile(input: $input) {
      uploadUrl
      fileId
      s3Key
    }
  }
`;

export const REMOVE_FILE_FROM_ASSET = gql`
  mutation RemoveFileFromAsset($assetId: ID!, $fileId: ID!) {
    removeFileFromAsset(assetId: $assetId, fileId: $fileId) {
      ...AssetFields
    }
  }
  ${ASSET_FRAGMENT}
`;
